import { c as _c } from "react/compiler-runtime";
import { parseAsString, useQueryState } from 'nuqs';
import type { Subsection } from '@/components/entity-onboarding-details/onboarding-data.types';
import { getSubsectionAnchorId, ONBOARDINGS_ID } from '../constants';
import { pinScrollPosition } from '../utils';

/** Scrolls to a section of the selected onboarding, or to the strip, and holds it there while the page loads. */
const scrollToOnboarding = (subsection?: Subsection) => {
  const element = subsection && document.getElementById(getSubsectionAnchorId(subsection)) || document.getElementById(ONBOARDINGS_ID);
  if (!element) {
    return;
  }
  element.scrollIntoView({
    block: 'start'
  });
  pinScrollPosition(element, element.getBoundingClientRect().top);
};
const useShowOnboarding = () => {
  const $ = _c(6);
  const [onboardingId, setOnboardingId] = useQueryState("onboarding_id", parseAsString);
  let t0;
  if ($[0] !== setOnboardingId) {
    t0 = async (id, subsection) => {
      await setOnboardingId(id);
      requestAnimationFrame(() => scrollToOnboarding(subsection));
    };
    $[0] = setOnboardingId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const scrollOnboardingIntoView = t0;
  let t1;
  if ($[2] !== onboardingId || $[3] !== scrollOnboardingIntoView || $[4] !== setOnboardingId) {
    t1 = {
      onboardingId,
      setOnboardingId,
      scrollOnboardingIntoView
    };
    $[2] = onboardingId;
    $[3] = scrollOnboardingIntoView;
    $[4] = setOnboardingId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export { scrollToOnboarding };
export default useShowOnboarding;